import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/product-catalog/components/ProductCatalogInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
